module.exports = __webpack_public_path__ + "img/ic_nodocument.81e2d971.png";